// section: main-blog-post
theme.Article = (function(){
  function Article(container){
    this.container = container;
    this.summary();
  }

  Article.prototype = Object.assign({}, Article.prototype, {
    summary: function(){
      var h = this.container.getAttribute('data-hn'),
      nb = this.container.getAttribute('data-limit'),
      content = this.container.querySelector('.article-content'),
      summary = this.container.querySelector('.summary');
      let nb_titles = 0;

      for(i = 2; i <= h; i++){
        const titles = content.querySelectorAll("h" + i);
        nb_titles += titles.length;
      }

      if (nb_titles >= nb) {
        var ul = document.createElement('ul');
        if(this.container.querySelector('.link_collapsing_title')){
          ul.classList.add("link_collapsing_content");
          ul.style.display = "none";
        }
        ul.innerHtml = "";
        summary.appendChild(ul);
        var toc = "";
        var start = 4;
        var children = content.children;

        for (var i = 0; i < children.length; i++) {
          if(children[i].nodeName.match(/^H\d+$/)){
            var level = children[i].nodeName.substr(1);
            if(level <= h){
              var headerText = (children[i].textContent);
              var anchor = "toc-" + i;

              var tag = '<a href="#' + anchor + '" id="' + anchor + '">' + headerText + '</a>';

              children[i].innerHTML = tag;

              if(headerText){
                  if (level > start) {
                    toc += (new Array(level - start + 1)).join('<ul>');
                  } else if (level < start) {
                    toc += (new Array(start - level + 1)).join('</li></ul>');
                  } else {
                    toc += (new Array(start+ 1)).join('</li>');
                  }
                  start = parseInt(level);
                  toc += '<li><a href="#' + anchor + '">' + headerText + '</a>';
              }
            }
          }
        }

        if (start) {
          toc += (new Array(start + 1)).join('</ul>');
        }

        ul.innerHTML += toc;
        summary.querySelector(".link_collapsing_title").style.opacity = "";
        summary.classList.remove('loading-gradient');
      } else {
        summary.classList.add('hide');
        return;
      }

      ul.querySelectorAll("a[href*='#']:not([href='#'])").forEach( (link) => {
        link.addEventListener("click", function() {
          if(location.hostname == this.hostname && this.pathname.replace(/^\//,"") == location.pathname.replace(/^\//,"")) {
            var anchor = this.hash;
            anchor = anchor.length ? anchor : content.querySelector("[name=" + this.hash.slice(1) +"]");
            if( anchor.length ) {
              var rect = document.querySelector(anchor).getBoundingClientRect();
              var offsetTop = rect.top + window.scrollY;
              theme.utils.scrollToSmoothly(offsetTop, 500);
            }
          }
        });
      })
    }
  });

  return Article;
})();

class ProgressBar extends HTMLElement {
  constructor(){
    super();

    var self = this;
    this.namespace = '.progress-bar';
    self.dataScroll = document.querySelector('.header').getAttribute('data-scroll');
    self.dataScrollMob = document.querySelector('.header').getAttribute('data-scroll-mob');

    this.bindEvents();

    document.addEventListener('shopify:section:load', function(){
      self.bindEvents();
    });

    window.on('resize'+ this.namespace, theme.utils.debounce(300, function() {
      self.bindEvents();
      setTimeout(function(){ 
        if(((self.dataScroll != "none" && document.documentElement.clientWidth >= 780) || (self.dataScrollMob != "none" && document.documentElement.clientWidth < 780)) && document.documentElement.clientHeight + 200 < document.body.getBoundingClientRect().height){
          self.scroll = document.documentElement.clientWidth >= 780 ? self.dataScroll : self.dataScrollMob;
          if((document.body.classList.contains('header__sticky') && self.scroll == "sticky") || (document.body.classList.contains('header__sticky') && document.body.classList.contains('scroll_up') && self.scroll == "up")) {
            self.style.transform = 'translateY('+ document.querySelector('.header').getBoundingClientRect().height + 'px)';
  
            self.closest('.section-container').querySelectorAll('.position--sticky').forEach((sticky) => {
              sticky.style.top = document.querySelector('.header').getBoundingClientRect().height + self.getBoundingClientRect().height + 20 + "px"
            });
          } else {
            self.style.transform = '';
  
            self.closest('.section-container').querySelectorAll('.position--sticky').forEach((sticky) => {
              sticky.style.top = document.querySelector('.header').getBoundingClientRect().height + 20 + "px"
            });
          }
        }
      }, 0.1)
    }));
  }

  bindEvents(){
    var self = this;
    window.addEventListener("scroll", theme.utils.debounce(10, function(){ self.onScroll() }))
  }

  onScroll(){
    var self = this;
    setTimeout(function(){
      if(((self.dataScroll != "none" && document.documentElement.clientWidth >= 780) || (self.dataScrollMob != "none" && document.documentElement.clientWidth < 780)) && document.documentElement.clientHeight + 200 < document.body.getBoundingClientRect().height){
        self.scroll = document.documentElement.clientWidth >= 780 ? self.dataScroll : self.dataScrollMob;
        if((document.body.classList.contains('header__sticky') && self.scroll == "sticky") || (document.body.classList.contains('header__sticky') && document.body.classList.contains('scroll_up') && self.scroll == "up")) {
          self.style.transform = 'translateY('+ document.querySelector('.header').getBoundingClientRect().height + 'px)';

          self.closest('.section-container').querySelectorAll('.position--sticky').forEach((sticky) => {
            sticky.style.top = document.querySelector('.header').getBoundingClientRect().height + self.getBoundingClientRect().height + 20 + "px"
          });
        } else {
          self.style.transform = '';

          self.closest('.section-container').querySelectorAll('.position--sticky').forEach((sticky) => {
            sticky.style.top = document.querySelector('.header').getBoundingClientRect().height + 20 + "px"
          });
        }
      }
    }, 0.1)

    var articleTop = document.querySelector('.header').getBoundingClientRect().height + 250
      , articleBottom = document.querySelector("article.article-container").offsetTop + document.querySelector("article.article-container").getBoundingClientRect().height;
    articleTop + .7 * articleTop < window.scrollY && articleBottom - 200 > window.scrollY ? this.setAttribute("aria-hidden", "false") : this.setAttribute("aria-hidden", "true");

    var i = this.getBoundingClientRect(),
    r = document.querySelector("article.article-container").getBoundingClientRect(),
    a = r.bottom - i.bottom,
    o = Math.abs(a / r.height - 1);
    this.querySelector('.article__progress-bar').style.width = 100 * o + "%"
  }
}

customElements.define('progress-bar', ProgressBar);